import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    PORTDATA,
    EXTERNALDEVICES,
    // allPortDefaultData,
    // generateDeviceDataKey,
} from '../defaultData'
import { generateDeviceDataKey } from '../../ReusableComponents/ByteTransfer/utils'

const availableExternalPorts = [31, 32, 33, 34, 35, 36, 37, 38]
const availableExternalPortsKlaw = [31, 32, 33, 34]
const availableAiInputPorts = Array.from(
    { length: 103 - 82 + 1 },
    (_, i) => i + 82
)
//for start panel assigned port
const startPanelPortObj = {
    Bicounter1: {
        port: 52,
    },
    Bicounter2: {
        port: 53,
    },
    BiData1: {
        port: 54,
    },
    BiData2: {
        port: 63,
    },
    Biflag1: {
        port: 55,
    },
    Biflag2: {
        port: 56,
    },
    'BT RX1': {
        port: 57,
    },
    'BT RX2': {
        port: 58,
    },
    'BT RX3': {
        port: 59,
    },
    'BT RX4': {
        port: 60,
    },
    'BT RX5': {
        port: 61,
    },
    'USB RX': {
        port: 62,
    },
    'BT Remote': {
        port: 64,
    },
}

const joystickLabels = {
    JOY_BUTTON_Y: 'JY - Y',
    JOY_BUTTON_B: 'JY - B',
    JOY_BUTTON_A: 'JY - A',
    JOY_BUTTON_X: 'JY - X',
    JOY_BUTTON_MENU: 'JY - MENU',
    JOY_BUTTON_GUIDE: 'JY - GUIDE',
    JOY_BUTTON_VIEW: 'JY - VIEW',
    JOY_DPAD_UP: 'JY - DPAD UP',
    JOY_DPAD_DOWN: 'JY - DPAD DOWN',
    JOY_DPAD_LEFT: 'JY - DPAD LEFT',
    JOY_DPAD_RIGHT: 'JY - DPAD RIGHT',
    JOY_LSB_UP: 'JY - LSB UP',
    JOY_LSB_DOWN: 'JY - LSB DOWN',
    JOY_LSB_RIGHT: 'JY - LSB RIGHT',
    JOY_LSB_LEFT: 'JY - LSB LEFT',
}

class Select extends Component {
    constructor(props) {
        super(props)
        this.state = {
            // none
        }
        this.aiInputOptions = []
    }

    componentDidMount = () => {
        if (this.props.selected)
            this.props.onChange({ target: { value: this.props.selected } })
        this.getAiInputOption()
    }

    onChange = (e) => {
        this.props.onChange(e.target.value)
    }

    decideRenderPort = (portId) => {
        const portConnections = this.props.assembly.PortConnections
        const connectedDevice = sessionStorage.getItem('connectedDevice')
        const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
        const PORTDATAKey = generateDeviceDataKey(
            connectedDevice,
            deviceVersion
        )
        const EXTERNALDEVICESData =
            ['0', '1'].includes(deviceVersion[0]) &&
            ['Hexapod', 'Humanoid'].includes(connectedDevice)
                ? EXTERNALDEVICES['v1']
                : EXTERNALDEVICES['v2']
        // console.log(PORTDATA[`${connectedDevice.toUpperCase()}`], portId)
        const portName = PORTDATA[PORTDATAKey][portId].name.split(' ')[1]
        // Full-port components (e.g. ultrasonic_sensor/_v1 on Hexapod/Klaw/Ace)
        // are stored under the bare port letter only (workspace.js's generic
        // PortConnections[connectedTo] fallback), not per sub-pin - fall back
        // to that. Only surface it via the port's "1" sub-id (A1, not A2) since
        // there's a single physical reading for the whole port, not two.
        const isBarePortFallback =
            portConnections[portName] == null && portName.slice(-1) === '1'
        const conn = isBarePortFallback
            ? portConnections[portName.slice(0, -1)]
            : portConnections[portName]
        if (conn == null) return { isRenderPort: false }

        const externalDevice = conn.type
        if (externalDevice == 'pcAiTool') {
            return { isRenderPort: false }
        }

        if (EXTERNALDEVICESData[externalDevice].type == 'output')
            return { isRenderPort: false }

        // not render dual channel devices on [ABCD]2 ports
        // if (
        //     portName[1] == '2' &&
        //     portConnections[portName].type == portConnections[portName[0]].type
        // )
        //     return { isRenderPort: false }

        let displayName = EXTERNALDEVICESData[externalDevice].name
        if (
            (externalDevice === 'joystick_v2' ||
                externalDevice === 'joystick') &&
            conn.joystickRole
        ) {
            displayName =
                conn.joystickRole === 'x'
                    ? 'Joystick X'
                    : conn.joystickRole === 'y'
                      ? 'Joystick Y'
                      : 'Tact switch'
        }

        return {
            isRenderPort: true,
            btnText: `${displayName} -> ${portName}`,
            portName: externalDevice,
        }
    }

    checkForOtherComp = (port, deviceName) => {
        if (
            ['A', 'D', 'C'].includes(port[1].name.slice(-2, -1)) &&
            JSON.parse(
                sessionStorage.getItem(`${port[1].name.slice(-2, -1)}Ultra`)
            )
        ) {
            return `Ultrasonic -> ${port[1].name}`
        } else {
            return `${port[1].name} - ${port[1].type2}`
        }
    }

    getAiInputOption = () => {
        const connectedDevice = sessionStorage.getItem('connectedDevice')
        const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
        let PORTDATAKey = generateDeviceDataKey(connectedDevice, deviceVersion)
        if (
            ![
                'HUMANOID2',
                'HUMANOID3',
                'HEXAPOD2',
                'KLAW1',
                'HEXAPOD3',
            ].includes(PORTDATAKey)
        ) {
            PORTDATAKey = 'PORTDATAKey'
        }
        const defaultPortData = PORTDATA[PORTDATAKey]

        // let aiTrainList = {}
        // try {
        //     aiTrainList = JSON.parse(localStorage.getItem('aiTrainList'))
        // } catch (e) {
        //     console.log('ERROR', e)
        // }

        let assemblyPageAiItems = this.props?.assembly?.assemblyPageAi?.aiItems
        let aiFaceList = this.props?.assembly?.assemblyPageAi?.aiFaceList
        availableAiInputPorts.map((portNumber) => {
            let portDetails = defaultPortData?.[portNumber]

            if (!assemblyPageAiItems?.[portDetails?.reduxName]) {
                return
            }

            if ([84, 88].includes(portNumber)) {
                return
            }

            // if ([85, 86, 87, 89, 90, 91].includes(portNumber)) {
            //for read pa bytes ai color tracking do not show
            // if (this.props.typeDropDown === 'readPa') {
            //     return
            // }
            // let trainKey =
            //     parseInt(portDetails?.reduxLogicName[0]?.slice(-1) || '1') -
            //     1
            // if (!aiTrainList?.colorTranList?.[trainKey]?.isUpload) {
            //     return
            // }
            // }
            if ([96, 97, 98, 99, 100, 101].includes(portNumber)) {
                //for read pa bytes ai face tracking do not show
                // if (this.props.typeDropDown === 'readPa') {
                //     return
                // }

                let trainKey = parseInt(
                    portDetails?.reduxLogicName[0]?.slice(-1) || '0'
                )
                // if (!aiTrainList?.faceTranList?.[trainKey]?.isUpload) {
                //     return
                // }
                if (aiFaceList?.length <= trainKey) {
                    return
                }

                let label = portDetails.name.replace(
                    'Names',
                    aiFaceList[trainKey].label
                )
                let obj = {
                    label: label,
                    value: portNumber,
                }
                this.aiInputOptions.push(obj)
            } else {
                let obj = { label: portDetails.name, value: portNumber }
                this.aiInputOptions.push(obj)
            }
        })
    }
    getStartPanelOptionLabel(ele) {
        if (
            ['Bicounter1', 'Bicounter2', 'Biflag1', 'Biflag2', 'BiData1', 'BiData2'].includes(ele)
        )
            return ele.replace(/^Bi(.)/, (m, c) => c.toUpperCase())
        return ele
    }

    render() {
        var style = {
            border: '2.1px solid #3C413E',
            borderRadius: '15px',
            color: '#000',
            background: '#FFF',
            height: '100%',
            width: '100%',
            outline: 'none',
            texAlign: 'center',
            fontFamily: 'Halcyon_Semibold !important',
        }

        let humanoidPortData = JSON.parse(
            sessionStorage.getItem('humanoidPortData')
        )
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        return (
            <>
                {this.props.typeDropDown !== 'trainList' && (
                    <select
                        style={style}
                        value={this.props.selected}
                        onChange={this.props.onChange}
                    >
                        <option selected value="battery">
                            {' '}
                            Select Items
                        </option>

                        {/* External Accessories */}
                        {connectedDevice == 'Klaw' &&
                            availableExternalPortsKlaw.map((portId) => {
                                const { isRenderPort, btnText, portName } =
                                    this.decideRenderPort(portId)
                                if (!isRenderPort) return
                                return (
                                    <>
                                        <option key={portName} value={portId}>
                                            {btnText}
                                        </option>
                                    </>
                                )
                            })}
                        {connectedDevice !== 'Klaw' &&
                            availableExternalPorts.map((portId) => {
                                const { isRenderPort, btnText, portName } =
                                    this.decideRenderPort(portId)
                                if (!isRenderPort) return
                                return (
                                    <>
                                        <option key={portName} value={portId}>
                                            {btnText}
                                        </option>
                                    </>
                                )
                            })}

                        {/* Internal Accessories sourceOptionsOrder*/}
                        {Object.entries(humanoidPortData).map((port) => {
                            // console.log('JJJJJJJJJJJ', port)
                            if (
                                port[1].type === 'input' &&
                                port[1].isPortSelected
                            ) {
                                let deviceName = ''
                                switch (connectedDevice) {
                                    case 'Klaw':
                                        deviceName = 'Klaw-b '
                                        break
                                    case 'Hexapod':
                                        deviceName = 'Crawl-e '
                                        break
                                    case 'Humanoid':
                                        deviceName = 'Zing '
                                        break
                                    default:
                                        deviceName = 'PC '
                                }
                                return (
                                    <>
                                        {connectedDevice == 'Hexapod' ? (
                                            <option
                                                key={port[0]}
                                                value={port[0]}
                                            >
                                                {port[0] < 31 &&
                                                    `${deviceName} ${port[1].name}`}
                                                {port[0] > 31 &&
                                                    this.checkForOtherComp(
                                                        port,
                                                        deviceName
                                                    )}
                                            </option>
                                        ) : (
                                            <option
                                                key={port[0]}
                                                value={port[0]}
                                            >
                                                {port[0] < 30 &&
                                                    `${deviceName} ${port[1].name}`}
                                                {port[0] > 30 &&
                                                    this.checkForOtherComp(
                                                        port,
                                                        deviceName
                                                    )}
                                            </option>
                                        )}
                                    </>
                                )
                            }
                            return
                        })}

                        {/* ai accessories */}
                        {this.aiInputOptions &&
                            this.aiInputOptions.map((ele, ind) => {
                                return (
                                    <option key={ind} value={ele.value}>
                                        {ele.label}
                                    </option>
                                )
                            })}

                        {/* for start panel */}
                        {this.props.type !== 'read' &&
                            this.props.sourceOptionsOrder &&
                            this.props.sourceOptionsOrder.map((ele, key) => {
                                if (ele.startsWith('JOY_')) {
                                    return (
                                        <option key={key} value={ele}>
                                            {joystickLabels[ele] || ele}
                                        </option>
                                    )
                                }

                                if (!startPanelPortObj[ele]) return null
                                return (
                                    <>
                                        <option
                                            key={key}
                                            value={startPanelPortObj[ele].port}
                                        >
                                            {/* {deviceName + ele} */}
                                            {this.getStartPanelOptionLabel(ele)}
                                        </option>
                                    </>
                                )
                            })}
                    </select>
                )}

                {this.props.typeDropDown == 'trainList' && (
                    <select
                        style={style}
                        value={this.props.selected}
                        onChange={this.props.onChange}
                    >
                        {this.props?.tranListOption?.map((ele, ind) => {
                            return (
                                <option key={ind} value={ele.id}>
                                    {ele.label}
                                </option>
                            )
                        })}
                    </select>
                )}
            </>
        )
    }
}
const mapStateToProps = (state) => {
    return state
}
export default connect(mapStateToProps)(Select)
